import React, {useState} from 'react';
import {logPageLoadEvents, sendEvarData} from '@ibibo/analytics';
import OtpInput from 'react-otp-input';
import Spinner from '../Spinner/Spinner';

import * as S from './OtpField.styles';

const OtpField = ({
  labelText,
  resendOtp,
  inputVal = '',
  numOfInput = 6,
  onChange,
  showLoader,
  resendOtpCaller,
  disableResendOtp,
  editNumber,
  setShowOtpScreen,
}) => {
  const [otp, setOtp] = useState('');

  const handleChange = opt => {
    setOtp(opt);
    onChange && onChange(opt);
  };

  const resetOtpHandler = () => {
    resendOtpCaller && resendOtpCaller();
    setOtp('');
  };

  const editNumberHandler = () => {
    setShowOtpScreen && setShowOtpScreen(false);
    //myPartner_onboarding_editMobile;
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:mobileotpvalidation|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/login/',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      eVar54: 'myPartner_onboarding_editMobile',
    });
  };

  return (
    <S.Container>
      {labelText && <S.LabelText>{labelText}</S.LabelText>}
      <S.InputCont>
        <OtpInput value={otp} onChange={handleChange} numInputs={numOfInput} />
        {showLoader && otp && otp.length === 6 && (
          <Spinner width="32px" height="32px" borderWidth="4px" />
        )}
      </S.InputCont>
      {resendOtp && (
        <S.Resend isDisabled={disableResendOtp} onClick={resetOtpHandler}>
          {resendOtp}
        </S.Resend>
      )}
      <br />
      {editNumber && (
        <S.Resend isDisabled={disableResendOtp} onClick={editNumberHandler}>
          {editNumber}
        </S.Resend>
      )}
    </S.Container>
  );
};

export default OtpField;
